export default __webpack_public_path__ + "static/media/noh5p.b216c56f.svg";